export function decodeParams(raw) {
    return raw
        .replace(/^(#|\?)/, '')
        .split('&')
        .reduce((parsed, param) => {
        const [key, value = ''] = param.split('=');
        return Object.assign(Object.assign({}, parsed), { [decodeURIComponent(key)]: decodeURIComponent(value) });
    }, {});
}
export function encodeParams(params) {
    return Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');
}
/**
 * sends a request to the specified url from a form. this will change the window location.
 * @param {string} path the path to send the post request to
 * @param {object} params the parameters to add to the url
 * @param {string} [method=post] the method to use on the form
 */
export function postForm(path, params, method = 'post') {
    // The rest of this code assumes you are not using a library.
    // It can be made less verbose if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;
    Object.keys(params).forEach((key) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = params[key];
        form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();
}
export function isSafeURL(url) {
    try {
        const { protocol } = new URL(url);
        // eslint-disable-next-line no-script-url
        return protocol !== 'javascript:';
    }
    catch (_a) {
        return true;
    }
}
